<template lang="pug">
section
    .title-page
        .container
            h2 Appel d'offre
    //.alert.alert-primary.border-0.text-center.rounded-0.m-0(v-if='!isAuth')
    //  | Essayez Tendfox gratuitement pendant 7 jours.
    //  router-link(to='/register', tag='a', class="nav-item", v-if='!isAuth')  Inscrivez-vous
    .container.pt-5
        .row
            .col-sm-12.col-lg-3.mb-3.order-1.order-lg-1
                h3.tf_title.text-uppercase.text-center Filtres
            .col-sm-12.col-lg-9.order-3.order-lg-2
                h3.tf_title.text-uppercase.text-center.total_list Liste totale des annonces <br>
                    small {{ listeaosPagination.total }} résultats
            filtrerecherche
            .col-md-12.col-sm-12.col-lg-9.order-last.mt-sm-3.mt-md-0
                img.img-fluid.mx-auto.d-block.mb-3(
                    :src="pubImage",
                    alt="SARL FAST INFORMQTIQUE"
                )
                .recap_filters.alert.tf_alert_filter.d-flex(
                    v-if="!isEquivalent(activeFilter, baseFilter)"
                )
                    ul.list-inline.mb-0.textual-filters
                        li.list-inline-item(
                            v-if="activeFilter.searchText !== ''"
                        )
                            span.filtre Mot Clés :
                            span.filtre_result {{ activeFilter.searchText }}
                        li.list-inline-item(
                            v-if="activeFilter.searchText !== ''"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchCode !== ''"
                        )
                            span.filtre Code :
                            span.filtre_result {{ activeFilter.searchCode }}
                        li.list-inline-item(
                            v-if="activeFilter.searchCode !== ''"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchStatut.length !== 0"
                        )
                            span.filtre Status :
                            span.filtre_result {{ getFiltreStatut() }}
                        li.list-inline-item(
                            v-if="activeFilter.searchStatut.length !== 0"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchType.length !== 0"
                        )
                            span.filtre Type :
                            span.filtre_result {{ activeFilter.searchType.map((type) => (type === "national" ? "National" : "National & international")).join(', ')  }}
                        li.list-inline-item(
                            v-if="activeFilter.searchType.length !== 0"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchWilaya.length !== 0"
                        )
                            span.filtre Wilaya :
                            span.filtre_result {{ getFiltreWilaya() }}
                        li.list-inline-item(
                            v-if="activeFilter.searchWilaya.length !== 0"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchAnnonceur.length !== 0"
                        )
                            span.filtre Annonceur :
                            span.filtre_result {{ getFiltreAnnonceur() }}
                        li.list-inline-item(
                            v-if="activeFilter.searchAnnonceur.length !== 0"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.searchSecteur.length !== 0"
                        )
                            span.filtre Secteur :
                            span.filtre_result {{ getFiltreSecteur() }}
                        li.list-inline-item(
                            v-if="activeFilter.searchSecteur.length !== 0"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.datePublication.type !== null"
                        )
                            span.filtre Date publication :
                            span.filtre_result {{ datePublicationAsString }}
                        li.list-inline-item(
                            v-if="activeFilter.datePublication.type !== null"
                        ) |
                        li.list-inline-item(
                            v-if="activeFilter.dateEcheance.type !== null"
                        )
                            span.filtre Date fin :
                            span.filtre_result {{ dateFinAsString }}
                        li.list-inline-item(
                            v-if="activeFilter.dateEcheance.type !== null"
                        ) |
                    .save_filters.d-flex
                        button.btn.btn-primary(
                            role="button",
                            @click="openModalFilter()",
                            v-if="!isEquivalent(activeFilter, baseFilter) && checkedSavedFilter.length === 0 && statusCompte === ''"
                        ) Ajouter a<br>mes Filtres
                        button.btn.btn-primary.disabled(
                            role="button",
                            v-if="checkedSavedFilter.length > 0"
                        ) {{ checkedSavedFilter[0].nom }}
                        el-dialog(
                            title="Ajouter mon filtre",
                            :visible.sync="dialogFormVisible",
                            width="30%"
                        )
                            .modal-body
                                label Nom du filtre
                                input.form-control.form-control-lg(
                                    :data-vv-as="$t('user.nom')",
                                    placeholder="nom",
                                    name="name",
                                    data-vv-name="name",
                                    v-validate="'required'",
                                    data-vv-rules="required",
                                    :class="{ 'is-invalid': errors.has('name') }",
                                    v-model="nomFiltre",
                                    auto-complete="off",
                                    v-on:keyup.enter="addFiltre()"
                                )
                                .invalid-feedback(
                                    v-show="errors.first('name')"
                                ) {{ errors.first('name') }}
                            span.dialog-footer(slot="footer")
                                button.btn.btn-primary(
                                    type="primary",
                                    @click.prevent="addFiltre()"
                                ) Ajouter
                        button.btn.btn-outline-secondary.ml-2(
                            title="Rénitialisé la recherche",
                            role="button",
                            @click="reloadPage"
                        )
                            i.fa.fa-refresh
                div(
                    style="padding-top: 6%",
                    v-loading="chargementTable",
                    v-if="chargementTable"
                )
                table.table.mb-0.table-striped.list_recherche.table-bordered(
                    v-show="!chargementTable"
                )
                    tbody
                        tr.py-0.m-0(v-for="list in listeaos")
                            td.py-1
                                .row
                                    .col-12
                                        a.text-dark.row(
                                            :href="getLinkAppel(list.id)",
                                            @click.prevent="getFicheAppel(list, $event)",
                                            :rel="''"
                                        )
                                            .col-12.col-sm-12.col-md-5.d-flex.order-sm-0.order-0.order-md-0
                                                .last_ao_title.w-100 {{ list.titre }}
                                            .col-12.col-sm-12.col-md-5.d-flex.order-sm-2.order-2.order-md-1
                                                .last_ao_entreprise.w-100(
                                                    v-if="!list.is_restricted"
                                                ) {{ list.annonceur.nom }}
                                                .last_ao_entreprise.w-100(
                                                    v-if="haveAccessSecteur && list.is_restricted",
                                                    style="text-transform: none"
                                                )
                                                    i.text-primary.fa.fa-lock(
                                                        aria-hidden="true"
                                                    )
                                                    |
                                                    | {{ erreurAcces }}
                                            .col-6.col-sm-6.col-md-2.order-sm-4.order-4.order-md-2
                                                .last_ao_date
                                                    .last_ao_date_start
                                                        i.fa.fa-play.mr-2.text-gold(
                                                            v-show="list.datePublication !== ''"
                                                        )
                                                        span {{ getFormatDate(list.datePublication) }}
                                            .col-12.col-sm-12.col-md-5.order-sm-1.order-1.order-md-3
                                                .last_ao_info
                                                    span.text-primary {{ getStatutAo(list.statut) }}
                                                    span.text-right.text-primary.float-right {{ joinWilayasNames(list.wilaya) }}
                                            .col-12.col-sm-12.col-md-5.order-sm-3.order-3.order-md-4
                                                .last_ao_categorie.bg-primary(
                                                    v-show="list.secteursActivites.length > 0"
                                                ) {{ getSecteurs(list.secteursActivites) }}
                                            .col-6.col-sm-6.col-md-2.order-sm-last.order-last.order-md-last
                                                .last_ao_date.last
                                                    .last_ao_date_stop
                                                        i.fa.fa-stop.mr-2.text-primary(
                                                            v-show="list.dateEcheance !== ''"
                                                        )
                                                        span {{ getFormatDate(list.dateEcheance) }}
                .col-12.p-0
                    el-pagination.d-flex.justify-content-center(
                        v-show="!chargementTable",
                        @size-change="handleSizeChange",
                        @current-change="handleCurrentChange",
                        :current-page="listeaosPagination.current_page",
                        :page-size="listeaosPagination.per_page",
                        layout="slot",
                        :total="listeaosPagination.total",
                        :pager-count="5"
                    )
                        custom-pagination(:goTo="setAppelOffrePage")
        el-dialog(
            title="Connexion requise",
            :visible.sync="dialogLoginVisible",
            width="30%"
        )
            .text-center
                p.mb-3
                    | Connectez-vous afin de visualiser l’intégralité de la publication :
                    br
                    router-link.nav-item(to="/login", tag="a", v-if="!isAuth") Connexion
                p.mb-3 Ou
                p
                    | Si vous n’avez pas encore de compte
                    br
                    router-link.nav-item(
                        to="/register",
                        tag="a",
                        v-if="!isAuth"
                    ) Inscrivez-vous gratuitement
                    br
                    | Et profitez d’une période d’essai gratuite
        el-dialog(
            title="Abonnement requis",
            :visible.sync="dialogAbonnementVisible",
            width="30%"
        )
            p
                | Pour pouvoir visualiser le contenu des annonces vous devez disposer d'un
                router-link.nav-item(to="/tfabonnement", tag="a") abonnement
                |
                | annuel payant ! Contactez nous au +213 (0) 560 545 282
</template>
<script>
import filtrerecherche from './filtrerecherche'
import resutlatrecherche from './resutlatrecherche'
import Vue from 'vue'
import EventBus from './../eventBus'
import customPagination from '../custom-pagination'

import VueEvents from 'vue-events'
import {isEqual} from 'lodash-es'
import Vuex from 'vuex'
import moment from 'moment'
import pubImage from '@/assets/images/pub/sarl-fast-informatique.jpg'
import {
  Loading,
  Dialog,
  Form,
  FormItem,
  Input,
  Pagination
} from 'element-ui'
global.v = Vuex
Vue.use(Input)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(FormItem)
Vue.use(VueEvents)
Vue.use(Pagination)
export default {
  store: window.store,
  created () {
    if (typeof this.$route.query.page !== 'undefined') {
      this.setAppelOffrePage(parseInt(this.$route.query.page))
    }
    let loadingInstance = Loading.service({
      fullscreen: true
    })
    this.$nextTick(() => {
      setTimeout(() => {
        loadingInstance.close()
      }, 1000)
    })
  },
  data () {
    return {
      initRechercheAo: false,
      pubImage: pubImage,
      erreurAcces: '',
      baseFilter: {
        searchText: '',
        searchCode: '',
        searchStatut: [],
        searchType: [],
        searchWilaya: [],
        searchAnnonceur: [],
        searchSecteur: [],
        datePublication: {
          type: null,
          start: null,
          end: null
        },
        dateEcheance: {
          type: null,
          start: null,
          end: null
        }
      },
      appeloffre: '',
      filterText: '',
      lastPage: 1,
      perPage: 20,
      wilayas: [],
      secteursActivites: [],
      filtreRecherche: {},
      totalResultat: 0,
      page: 10,
      // listeaos: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      nomFiltre: '',
      dialogLoginVisible: false,
      dialogAbonnementVisible: false
    }
  },
  components: {
    filtrerecherche,
    resutlatrecherche,
    Input,
    Form,
    Dialog,
    Pagination,
    customPagination
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    if (to.name === 'ficheappeloffre') {
      this.setInitRechercheAoStore(false)
      next()
    } else {
      this.setInitRechercheAoStore(true)
      next()
    }
  },
  computed: {
    checkedSavedFilter () {
      return this.saveFilter.filter((filter) => filter.checked)
    },
    haveAccessSecteur () {
      if (this.canVieWAo()) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.erreurAcces = 'Niveau d\'accés insuffisant'
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.erreurAcces = 'Réservé aux abonnés'
      }
      return true
    },
    datePublicationAsString () {
      switch (this.activeFilter.datePublication.type) {
        case 'day': return 'Aujourd’hui'
        case 'week': return 'Cette semaine'
        case 'month': return 'Ce mois'
        case 'custom': return `Du ${this.getFormatDate(this.activeFilter.datePublication.start)} au ${this.getFormatDate(this.activeFilter.datePublication.end)}`
      }
    },
    dateFinAsString () {
      switch (this.activeFilter.dateEcheance.type) {
        case 'day': return 'Aujourd’hui'
        case 'week': return 'Cette semaine'
        case 'month': return 'Ce mois'
        case 'custom': return `Du ${this.getFormatDate(this.activeFilter.dateEcheance.start)} au ${this.getFormatDate(this.activeFilter.dateEcheance.end)}`
      }
    },
    ...Vuex.mapGetters(['profil', 'activeFilter', 'showFilter', 'listeaos', 'addButtonFilter', 'listeaosPagination', 'isAuth', 'saveFilter', 'statusCompte', 'chargementTable', 'searchFilter'])
  },
  methods: {
    joinWilayasNames (wilayas) {
      return wilayas.map(wilaya => wilaya.nom).join(', ')
    },
    reloadPage () {
      if (typeof this.$route.query.q !== 'undefined') {
        this.$router.push('/listappeloffre')
      }
      if (typeof this.$route.query.annonceur !== 'undefined') {
        this.$router.push('/listappeloffre')
      }
      document.location.reload()
    },
    isEquivalent (a, b) {
      return isEqual(a, b)
    },
    openModalFilter () {
      if (this.isAuth) {
        this.dialogFormVisible = true
      } else {
        this.dialogLoginVisible = true
      }
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    getFormatDate (data) {
      if (data !== '') {
        return moment(data).format('DD-MM-YYYY')
      } else {
        return ''
      }
    },
    setFilterDates (filtre) {
      switch (filtre.datePublication.type) {
        case null:
          filtre.datePublication.start = null
          filtre.datePublication.end = null
          break
        case 'day':
        case 'week':
        case 'month':
          filtre.datePublication.start = moment().startOf(filtre.datePublication.type).format('YYYY-MM-DD')
          filtre.datePublication.end = moment().endOf(filtre.datePublication.type).format('YYYY-MM-DD')
          break
      }
      switch (filtre.dateEcheance.type) {
        case null:
          filtre.dateEcheance.start = null
          filtre.dateEcheance.end = null
          break
        case 'day':
        case 'week':
        case 'month':
          filtre.dateEcheance.start = moment().startOf(filtre.dateEcheance.type).format('YYYY-MM-DD')
          filtre.dateEcheance.end = moment().endOf(filtre.dateEcheance.type).format('YYYY-MM-DD')
      }
      filtre.searchWilaya = filtre.searchWilaya.map((e) => {
        return this.wilayas.find((w) => w.id === e)
      })
      filtre.searchAnnonceur = filtre.searchAnnonceur.map((e) => {
        return this.annonceurs.find((a) => a.id === e)
      })
      filtre.searchSecteur = filtre.searchSecteur.map((e) => {
        return this.secteursActivites.find((s) => s.id === e)
      })
      return filtre
    },
    addFiltre () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        const searchWilaya = this.activeFilter.searchWilaya.map((wilaya) => wilaya.id)
        const searchAnnonceur = this.activeFilter.searchAnnonceur.map((annonceur) => annonceur.id)
        const searchSecteur = this.activeFilter.searchSecteur.map((secteur) => secteur.id)
        window.axios.post('/u/saved-searches', {
          nom: this.nomFiltre,
          searchText: this.activeFilter.searchText,
          searchCode: this.activeFilter.searchCode,
          searchStatut: this.activeFilter.searchStatut,
          searchType: this.activeFilter.searchType,
          searchWilaya: searchWilaya,
          searchAnnonceur: searchAnnonceur,
          searchSecteur: searchSecteur,
          datePublication: this.activeFilter.datePublication,
          dateEcheance: this.activeFilter.dateEcheance
        })
          .then(response => {
            EventBus.$emit('addNewFilter', response.data)
            // const filtre = this.setFilterDates(Object.assign({checked: true}, response.data))
            // this.setsaveFilterStore(filtre)
            this.nomFiltre = ''
            this.dialogFormVisible = false
            this.$notify({
              title: 'Sauvgarde filtre',
              message: 'Filtre sauvgardé avec succes',
              type: 'success'
            })
          })
      })
    },
    getFicheAppel (appelOffre, event) {
      /* if (!appelOffre.viewable) {
        if (!this.isAuth) {
          this.dialogLoginVisible = true
        } else {
          this.dialogAbonnementVisible = true
        }
      } else {

      } */
      if (event.ctrlKey) {
        window.open(`/ficheappeloffre/${appelOffre.id}`)
      } else {
        this.$router.push(`/ficheappeloffre/${appelOffre.id}`)
      }
    },
    canVieWAo () {
      if (this.isAuth) {
        return this.profil.services.filter((x) => x.name === 'Appel Offre').length > 0
      }
      return false
    },
    getLinkAppel (id) {
      return '/ficheappeloffre/' + id
    },
    getStatutAo (value) {
      switch (value) {
        case 'avis-appel-offre':
          return 'Appel d\'offres'
        case 'prorogation-delai':
          return 'Prorogation de délai'
        case 'attribution-marche':
          return 'Attribution de marché'
        case 'annulation':
          return 'Annulation'
        case 'infructuosite':
          return 'Infructuosité'
        case 'vente-enchere':
          return 'Vente aux enchères'
        case 'adjudication':
          return 'Adjudication'
        case 'mise-demeure-information':
          return 'Mise en demeure et résiliation'
        case 'consultation':
          return 'Consultation'
      }
    },
    getFiltreWilaya () {
      let searchWilaya = []
      this.activeFilter.searchWilaya.forEach(elem => {
        searchWilaya.push(elem.text)
      })
      return searchWilaya.join(', ')
    },
    getFiltreStatut () {
      let searchStatut = []
      let tmp = ''
      this.activeFilter.searchStatut.forEach(elem => {
        tmp = this.getStatutAo(elem)
        searchStatut.push(tmp)
      })
      return searchStatut.join(', ')
    },
    getFiltreAnnonceur () {
      let searchAnnonceur = []
      this.activeFilter.searchAnnonceur.forEach(elem => {
        searchAnnonceur.push(elem.nom)
      })
      return searchAnnonceur.join(', ')
    },
    getFiltreSecteur () {
      let searchSecteur = []
      this.activeFilter.searchSecteur.forEach(elem => {
        searchSecteur.push(elem.text)
      })
      return searchSecteur.join()
    },
    getSecteurs (secteursActivite) {
      const secteurs = secteursActivite.map(secteur => secteur.nom)
      return secteurs.join(', ')
    },
    handleSizeChange (val) {
    },
    handleCurrentChange (page) {
      window.scrollTo({
        top: 450,
        left: 100,
        behavior: 'smooth'
      })
      // document.body.scrollTo = -100
      /// document.documentElement.scrollTop = 100
      this.setAppelOffrePage(page)
    },
    voirFiche () {
      alert('voir la fiche')
    },
    ...Vuex.mapActions({
      'getProfilInfoStore': 'getProfilInfo',
      'getNotifStore': 'notifStore',
      'setsaveFilterStore': 'setsaveFilter',
      'setFilterStore': 'setFilter',
      'setListAppelOffreStore': 'setListAppelOffre',
      'setAppelOffrePage': 'setAppelOffrePage',
      'setInitRechercheAoStore': 'setInitRechercheAo',
      'updateSearchFilterStore': 'updateSearchFilter'
    })
  }
}
</script>

<style lang="css">
.searchable-table table thead {
    background: #3f342f !important;
}
.searchable-table table thead th {
    color: white;
}
.searchable-table table thead th:hover {
    color: #ec6b23 !important;
}
.pagination {
}
.page-item {
}
.textual-filters {
    flex: 2;
}
.recap_filters {
    align-items: start;
}
</style>
<style lang="css" scoped>
.recap_filters >>> li {
    display: inline;
}
ul.list-inline >>> li:last-child {
    display: none;
}
.text-dark {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/appeloffre/listappeloffre.vue